import React from 'react';
import { Nav } from './components/landing/Nav';
import { Hero } from './components/landing/Hero';
import { TrustStrip } from './components/landing/TrustStrip';
import { FeaturesBento } from './components/landing/FeaturesBento';
import { InActionTabs } from './components/landing/InActionTabs';
import { Compare } from './components/landing/Compare';
import { Testimonials } from './components/landing/Testimonials';
import { Pricing } from './components/landing/Pricing';
import { FinalCTA } from './components/landing/FinalCTA';
import { Footer } from './components/landing/Footer';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-zinc-800 selection:text-white" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustStrip data-id="element-4" />
        <FeaturesBento data-id="element-5" />
        <InActionTabs data-id="element-6" />
        <Compare data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Pricing data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}